<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>本地推送配置</span>
          <CommonExport :export-title="'导出'" :import-title="'导入'" :get-table="getTables" :import-method="importLocalPushCfg" :export-method="exportLocalPushCfg" />
          <!--          <el-button :loading="loading" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <syncVersion :in-method="localPushAsycnS3" />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-select v-model.number="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="(item, index) in typeArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="title_lang_key" label="名称(多语言KEY)" width="200px">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.title_lang_key" placeholder="名称(多语言KEY)" />
            </template>
          </el-table-column>
          <el-table-column prop="content_lang_key" label="名称(多语言KEY)" width="200px">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.content_lang_key" placeholder="名称(多语言KEY)" />
            </template>
          </el-table-column>
          <el-table-column prop="scope" label="几点">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.value" :disabled="scope.row.type !== 4" placeholder="几点" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" @click="del(scope.row.id, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-button type="primary" @click="add()">+</el-button>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  delLocalPushCfg,
  exportLocalPushCfg,
  getLocalPushCfg, getLocalPushType,
  importLocalPushCfg, localPushAsycnS3,
  updateLocalPushCfg
} from '@/api/config/local-push-cfg'
import CommonExport from '@/components/CommonExport/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'LocalPushCfg',
  components: { SyncData, SyncVersion, CommonExport },
  data() {
    return {
      loading: false,
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      langVisibleArr: [{ visible: false }],
      rewardType: [],
      typeArr: [],
      formData: [
        {
          id: 0,
          title_lang_key: '',
          content_lang_key: '',
          value: 0
        }
      ]
    }
  },
  created() {
    this.getType()
    this.getTables()
  },
  methods: {
    localPushAsycnS3,
    exportLocalPushCfg,
    importLocalPushCfg,
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.lang_key === '') {
          this.msgError('名称不能为空')
          return false
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateLocalPushCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getType() {
      getLocalPushType().then(res => {
        this.typeArr = []
        for (const i in res.data) {
          const val = res.data[i]
          this.typeArr.push({ label: val, value: parseInt(i), disabled: false })
        }
      })
    },
    getTables() {
      getLocalPushCfg(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
        this.listenType()
      })
    },
    add() {
      this.listenType()
      let select = 0
      for (const k in this.typeArr) {
        const val = this.typeArr[k]
        if (!val.disabled) {
          select = val.value
          break
        }
      }

      if (!select) {
        this.msgError('无可选类型')
        return
      }

      this.formData.push({
        id: 0,
        title_lang_key: '',
        content_lang_key: '',
        type: select,
        value: 0
      })
    },
    listenType() {
      for (const i in this.formData) {
        const val = this.formData[i]
        for (const k in this.typeArr) {
          const val2 = this.typeArr[k]
          if (val2.value === val.type) {
            this.typeArr[k].disabled = true
          }
        }
      }
    },
    del(id, index) {
      if (id <= 0) {
        this.formData = this.formData.filter((item, idx) => {
          return idx !== index
        })
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delLocalPushCfg({ id: id }).then(res => {
            this.getTables()
            this.msgSuccess(res.msg)
          })
        })
      }
    }
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     this.loading = true
    //     localPushAsycnS3({ name: this.name, type: this.key }).then(res => {
    //       if (res.code === 200) {
    //         this.loading = false
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
